import { Component, OnInit, inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule } from '@angular/common';
import { saveAs } from 'file-saver'; // Necesitas instalar esta biblioteca
import { HttpClient } from '@angular/common/http';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { EjecucionService } from '../../../services/ejecucion.service';


@Component({
  selector: 'app-inscripcion',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule],
  templateUrl: './inscripcion.component.html',
  styleUrl: './inscripcion.component.css'
})
export class InscripcionComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Output() vuelve = new EventEmitter<any>();
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  years: number[] = [];
  selectedYear: number = 0;
  user: any;
  resultado: any = [];
  filteredResultado: any[] = []; // Nuevo array para los resultados filtrados
  errorMessage: string = '';
  searchTerm: string = ''; // Variable para almacenar el término de búsqueda
  estado: any = [];
  sel_edo!: number;
  validador: boolean = true;
  // Nuevas propiedades para la selección:
  selectAll: boolean = false; // Estado del checkbox "Marcar Todos"
  valores: any = [];

  private srvLogin = inject(InicioService);
  private servicios = inject(EjecucionService);

  ngOnInit(): void {
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }


  ngAfterViewInit(): void {
    /*
    var idEdo = '';
    if(this.user.id_rol == 1 || this.user.id_rol == 11){
      idEdo = this.user.id_estado
    }
    else{
      idEdo = '1'
    }
      */

    var idEdo = this.user.id_estado;

    console.log('prueba usuario estado:    ',this.user.id_estado, '     id_rol:',this.user.id_rol)
    this.mdl.cargando();
    this.servicios.listarParticipantes(idEdo).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        console.log(rs.data);
        //this.resultado = rs.data.estudiante;
        let aa = rs.data['estudiante'].map((item: any) => ({ ...item, esSeleccion: false }));
        this.resultado = aa.filter((x:any) =>{ if(x.id_participante_acc == null) return x; })
        this.validador = this.resultado.length == 0 ? false : true;
        this.estado = rs.data.estado;
        this.sel_edo = parseInt(idEdo);
        this.filteredResultado = [...this.resultado]; // Inicializa los resultados filtrados con todos los datos
        this.selectAll = false; // Asegura que el maestro esté desmarcado
      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });
  }

  consulta_combos(){
    let estado = (document.getElementById('estado') as HTMLInputElement);
    this.mdl.cargando();
    this.servicios.listarParticipantes(estado.value).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.estado = rs.data['estado'];
        this.sel_edo = parseInt(estado.value);
        // Agrega esSeleccion: false
        let aa = rs.data['estudiante'].map((item: any) => ({ ...item, esSeleccion: false }));
        this.resultado = aa.filter((x:any) =>{ if(x.id_participante_acc == null) return x; })
        this.validador = this.resultado.length == 0 ? false : true;
        this.filteredResultado = [...this.resultado];
        this.selectAll = false; // Asegura que el maestro esté desmarcado
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  // Método para filtrar la tabla
  buscarAccionFormativa() {
    this.filteredResultado = this.resultado.filter((item: any) => {
      const identificacion = item.identificacion ? this.quitarAcentos(item.identificacion.toLowerCase()) : '';
      const nombre = item.nombre_full ? item.nombre_full.toLowerCase() : '';
      const estado = item.estado ? this.quitarAcentos(item.estado.toLowerCase()) : '';
      const term = this.searchTerm.toLowerCase();
      return (
        identificacion.includes(term) ||
        nombre.includes(term) ||
        estado.includes(term)
      );
    });
  }

  // 1. Maneja el checkbox maestro "Marcar Todos"
  seleccionaTodo() {
    // Aplica el estado del maestro (this.selectAll) a todos los elementos filtrados
    this.filteredResultado.forEach((item: any) => item.esSeleccion = this.selectAll);
  }

  // 2. Maneja los cambios de un checkbox individual
  seleccionaUno(item: any) {
    // Si un elemento se desmarca, el checkbox maestro también debe desmarcarse.
    if (!item.esSeleccion) {
      this.selectAll = false;
    } else {
      // Verifica si todos los elementos filtrados están seleccionados para marcar el maestro.
      let campo = (document.getElementById('buscar') as HTMLInputElement);
      // Si marcas un elemento, verifica si todos están marcados para marcar el maestro
      this.selectAll = campo.value == '' ? this.filteredResultado.every((r: any) => r.esSeleccion) : false;
    }
    /*
    const totalFiltered = this.filteredResultado.length;
    // 1. Lógica para el caso especial: Un solo registro visible
    if (totalFiltered === 1) {
      // Mantenemos 'selectAll' en false, sin importar si 'item' se marcó o desmarcó.
      this.selectAll = false;
    }
    // 2. Lógica para el caso normal: Más de un registro visible
    else if (totalFiltered > 1) {
      // Si un elemento se desmarca, el checkbox maestro también debe desmarcarse.
      if (!item.esSeleccion) {
          // Si desmarcas cualquier elemento, el maestro se desmarca
          this.selectAll = false;
      } else {
        let campo = (document.getElementById('buscar') as HTMLInputElement);
        console.log('asdasd:  ',campo.value)
        if (campo.value == ''){
          // Si marcas un elemento, verifica si todos están marcados para marcar el maestro
          this.selectAll = this.filteredResultado.every((r: any) => r.esSeleccion);
        }
        else{
          this.selectAll = false;
        }
      }
    }
    */
  }



  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  confirmacion(){
    this.valores = this.resultado.filter((d: any) => d.esSeleccion);
    if(this.valores.length == 0 ){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = 'Debe seleccionar al menos un(1) item.';
      this.mdl.alerta();
    }else{
      this.mdl.confirma();
    }
  }

  guardar_todo(){
    this.valores = this.resultado.filter((d: any) => d.esSeleccion);
    console.log('datos seleccionados:', this.valores);
    this.mdl.cargando();
    this.servicios.inscripcion(this.valores).subscribe({
      next: (rs) => {
        console.log('prueba:  ',rs)
        this.mdl.cerrar();
        this.servicios.listarParticipantes(this.sel_edo.toString()).subscribe({
          next: (rs) => {
            this.resultado = rs.data['estudiante'].map((item: any) => ({ ...item, esSeleccion: false }));
            this.validador = this.resultado.length == 0 ? false : true;
            this.estado = rs.data.estado;
            this.filteredResultado = [...this.resultado]; // Inicializa los resultados filtrados con todos los datos
            this.selectAll = false; // Asegura que el maestro esté desmarcado
          },
          error: (error) => {
            this.errorMessage = error.message;
          },
        });
        this.titulo = '!EXITO¡';
        this.tipo_color = 'success';
        this.letra_color = 'light';
        this.mensaje = 'Petición realizada.';
        this.mdl.alerta();
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  volver(){
    this.vuelve.emit({value: false, validador: false, warning: 0});
  }


}
